'use client'

import { useEffect, useRef } from 'react'

import useCarStoryHomeQuery from '../api/query/useCarStoryHomeQuery'
import { carStoryTracking } from '../lib'
import CarStoryTabError from './CarStoryTabError'
import CarStoryTabLoading from './CarStoryTabLoading'
import DriveAllSection from './DriveAllSection'
import DriveMagazineSwiper from './DriveMagazineSwiper'
import MechanicStoriesSection from './MechanicStoriesSection'
import PopularPlacesSection from './PopularPlacesSection'
import TrendingStoriesSection from './TrendingStoriesSection'
import VehicleManagementSection from './VehicleManagementSection'

const CarStoryHomePage = () => {
  const { data, isLoading, isError, refetch } = useCarStoryHomeQuery()

  const hasTrackedRef = useRef(false)
  useEffect(function trackHomePageView() {
    if (hasTrackedRef.current) return
    hasTrackedRef.current = true
    carStoryTracking.showHomePage()
  }, [])

  if (isLoading) return <CarStoryTabLoading />
  if (isError || !data) return <CarStoryTabError onRetry={refetch} />

  return (
    <div>
      <DriveMagazineSwiper items={data.mainContents} />
      {/* 지금 뜨는 이야기 */}
      <TrendingStoriesSection items={data.trending} />
      {/* 차량관리의 모든 것  */}
      <VehicleManagementSection items={data.carContents} />
      {/* 마이클 정비사 이야기 */}
      <MechanicStoriesSection items={data.mechanicSeries} />
      {/* 드라이브의 모든 것 */}
      <DriveAllSection items={data.driveContents} />
      {/* 인기 정비소 */}
      <PopularPlacesSection />
    </div>
  )
}

export default CarStoryHomePage
